
import Vue from 'vue';
import { Author } from '@root/modules/article/types/article';
import getAliasByLocale from '@root/common/utils/getAliasByLocale';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import AuthorImage from '@root/modules/author/components/AuthorImage.vue';
import { TranslateResult } from 'vue-i18n';

interface Props {
  author: Author;
  showTitle: boolean;
  showPicture: boolean;
  showInfo: boolean;
}

interface Computed {
  link: string | null;
  picture: string;
  role: TranslateResult | null;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    LinkHandler,
    AuthorImage,
  },
  props: {
    author: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: () => true,
      required: false,
    },
    showPicture: {
      type: Boolean,
      default: () => true,
      required: false,
    },
    showInfo: {
      type: Boolean,
      default: () => true,
      required: false,
    },
  },
  computed: {
    link() {
      const { id, locale } = this.$channelConfig('settings');
      const authorSlug = this.author.slug;

      if (!authorSlug) {
        return null;
      }

      const path = getAliasByLocale(locale, 'author');
      return `${id !== 'delfi' ? 'https://www.delfi.lt' : ''}/${path}/${authorSlug}/`;
    },
    picture() {
      return this.author?.image?.id || '';
    },
    role() {
      const role = this.author?.attributes?.find((attribute) => attribute.key === 'role')?.value;

      return this.$te(`article.author_roles.${role}`) ? this.$t(`article.author_roles.${role}`) : null;
    },
  },
});
